/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_PianoInputs */

const en_us2_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of a grand piano`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} grand pianos`)
	
};

const pt_br2_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um piano de cauda`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} pianos de cauda`)
	
};

const es_419_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de un piano de cola`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} pianos de cola`)
	
};

const pt_pt2_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um piano de cauda`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} pianos de cauda`)
	
};

const fr_fr2_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids d'un piano à queue`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} pianos à queue`)
	
};

const de_de2_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht eines Konzertflügels`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Konzertflügeln`)
	
};

const it_it2_equivalence_piano = /** @type {(inputs: Equivalence_PianoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso di un pianoforte a coda`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} pianoforti a coda`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of a grand piano" |
* | * | "the weight of {amount} grand pianos" |
*
* @param {Equivalence_PianoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_piano = /** @type {((inputs: Equivalence_PianoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_PianoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_piano(inputs)
	if (locale === "es-419") return es_419_equivalence_piano(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_piano(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_piano(inputs)
	if (locale === "de-DE") return de_de2_equivalence_piano(inputs)
	if (locale === "it-IT") return it_it2_equivalence_piano(inputs)
	return en_us2_equivalence_piano(inputs)
});
export { equivalence_piano as "equivalence.piano" }